/**
 * @generated SignedSource<<bcafd9a6c3fc8c99e3b5018102d74823>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ResourceType = "ARTICLE" | "ASSET" | "AUDIO" | "CLASS" | "CONTENT" | "COURSE" | "PODCAST" | "TALK" | "VIDEO" | "WORKSHEET";
import { FragmentRefs } from "relay-runtime";
export type ResourceCard_resource$data = {
  readonly format: string | null | undefined;
  readonly id: string;
  readonly imageCard: string | null | undefined;
  readonly isFavourite: boolean;
  readonly name: string;
  readonly slug: string;
  readonly type: ResourceType;
  readonly " $fragmentType": "ResourceCard_resource";
};
export type ResourceCard_resource$key = {
  readonly " $data"?: ResourceCard_resource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ResourceCard_resource">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ResourceCard_resource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageCard",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "format",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFavourite",
      "storageKey": null
    }
  ],
  "type": "Resource",
  "abstractKey": null
};

(node as any).hash = "61be962955a6d501a1a5d113f94378d2";

export default node;
